export default __webpack_public_path__ + "static/media/CNo.73-3.e1a86823.jpg";